import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { otherDeductionsDetailInputList2 } from '../../../common/data';
import { formatDate, formatNumber } from '../../../common/Util';

import ItemTitleSection from '../../../components/ItemTitleSection';
import TextField from '../../../components/common/TextField';

import Typography from '../../../components/common/Typography';
import { getBankList } from '../../common/commonSlice';

//장기집합투자증권
const Type2 = ({ handleAddButton }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation('deductions/other');
  const [dataList, setDataList] = useState([{ id: 1, data: {} }]);
  const { s11_2Data } = useSelector(state => state.otherDeductions);
  const { bankList } = useSelector(state => state.common);
  const inputFields = otherDeductionsDetailInputList2(t);

  useEffect(() => {
    if (bankList.length === 0) {
      dispatch(getBankList());
    }
  }, [bankList]);

  const renderField = (field, value, onChange) => {
    let fieldValue = field.isNumber ? formatNumber(value || '') : value?.trim() || '';
    fieldValue = field.isDate ? formatDate(fieldValue.replace(/-/g, '')) : fieldValue;

    let values = fieldValue;
    if (field.input == 'selectBox') {
      let codeList = [...field?.options];

      if (field.key != 'htm002') {
        const options = codeList.find(item => item.value == fieldValue?.trim());
        values = options?.label || '';
      } else {
        const options = bankList.find(item => item.bankCd?.trim() == fieldValue?.trim());
        values = options?.bankNm || '';
      }
    }

    return (
      <TextField label={field.label} value={values} onChange={() => {}} size="small" disabled />
    );
  };

  return (
    s11_2Data?.length > 0 && (
      <div className="displayFlexColumn" style={{ gap: '16px' }}>
        <ItemTitleSection
          title={t('detail.type2.title')}
          addButton={true}
          handleAddButton={handleAddButton}
        />

        {s11_2Data?.map((savings, index) => (
          <div key={index} className="savings-item">
            <div className="displayFlexBetween" style={{ marginBottom: '16px' }}>
              <Typography variant="body2Bold">
                {t('detail.type2.title')}
                {index + 1}
              </Typography>
            </div>

            <div className="displayFlexColumn" style={{ gap: '16px' }}>
              {inputFields.map((field, _index) => (
                <div key={_index}>
                  {renderField(field, savings[field.key], savings[field?.endKey])}
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    )
  );
};

export default Type2;
